import template from './socialPage.html';
import controller from './socialPage.controller';
import './socialPage.scss';

let socialPageComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default socialPageComponent;
